import { IOptionsWithTypes, spLogTags } from '@eventr/common'
import { ColoursObj } from '@eventr/common-storybook'
import { useEffect, useMemo, useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { ToolbarItemProps } from '../../../feat/layout/TopToolbar'
import {
    createChannel,
    useRocketChatContext,
} from '../../../feat/rocketchat/rocketChatProvider'
import { bs, useBoundStore } from '../../../state/bound.store'
import { loadingSignal } from '../../../state/overlayState/overlaySignals'
import { RocketChannel } from '../../../state/rocketchat/rocketchat.interface'
import { Utils } from '../../../utils'
export const useToolbarChat = (
    names: string[],
    users: IOptionsWithTypes[],
    sectionID: number,
    _id: string
) => {
    const { orgConfig, wpUser, selectedItinID, rocketchannels } = useBoundStore(
        useShallow((s) => {
            return {
                orgConfig: s.orgConfig,
                wpUser: s.wpUser,
                selectedItinID: s.selectedItinID,
                rocketchannels: s.rocketchannels[s.selectedItinID],
            }
        })
    )
    const { openChat, userRooms, isActivated } = useRocketChatContext()
    const [channel, setChannel] = useState<RocketChannel | undefined>()
    const [buttonState, setButtonState] = useState<
        'empty' | 'read' | 'unread' | 'loading' | undefined
    >()

    useEffect(() => {
        const chan = rocketchannels?.find((c) => {
            return c.object_id === _id
        })

        setChannel(chan)
    }, [rocketchannels, _id])
    useEffect(() => {
        if (channel && userRooms) {
            const room = userRooms.find((room) => {
                return room._id === channel.channel_id
            })
            if (room) {
                if ((room.unread ?? 0) > 0) {
                    setButtonState('unread')
                } else {
                    setButtonState('read')
                }
            } else {
                setButtonState(undefined)
            }
        } else {
            if (userRooms) {
                setButtonState(undefined)
            } else {
                setButtonState('loading')
            }
        }
    }, [userRooms, channel, setButtonState])
    const createOrNavigateToChannel = () => {
        if (channel && channel?.members?.includes(wpUser?.id!)) {
            openChat(channel?.channel_id, 'c' + channel.section_id)
        } else {
            loadingSignal.value = true

            if (names.length !== 0) {
                const u = users.filter((u) => u.type === 'User')
                createChannel({
                    channel_name_parts: names,
                    itinerary_id: selectedItinID,
                    section_id: sectionID,
                    user_ids: u.map((u) => u?.option as number),
                    _id: _id,
                })
                    .then((c) => {
                        if (c.status === 'success') {
                            if (c.data.channel_id)
                                openChat(c.data.channel_id, 'c' + sectionID)
                            bs().pullRocketChatChannels()
                        } else if (c.status === 'error') {
                            spLogTags('Error creating channel', [
                                'rocketchat',
                                'ERROR',
                            ])
                            spLogTags(c, ['rocketchat', 'ERROR'])
                        } else {
                            spLogTags(c, ['rocketchat', 'ERROR'])
                        }
                    })
                    .finally(() => {
                        loadingSignal.value = false
                    })
            }
        }
    }

    const enableChat = () => {
        if (users.length === 0) return false
        if (orgConfig?.disableChat) {
            return false
        }
        return isActivated
    }
    const iconName = useMemo(() => {
        if (buttonState === 'unread') {
            return 'Chat_Notf'
        }
        return 'Chat'
    }, [buttonState])

    if (!enableChat()) {
        return null
    }

    const chatButton: ToolbarItemProps = {
        id: 'chatButton',
        icon: iconName,
        action: () => {
            Utils.hapticFeedback('light')
            createOrNavigateToChannel()
        },
        colour:
            buttonState === 'read'
                ? ColoursObj.core.primary
                : ColoursObj.shades.shade2,
    }
    return chatButton
}
